class Option {
  description;

  logo;

  constructor(description, logo) {
    this.description = description;
    this.logo = logo;
  }

  async fetchDetails() {
    return {};
  }
}

export default Option;
